
import http from '@/assets/api/http';

// 财务信息，结算设置
export async function setCompanyRiderRatio(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.user.company.CompanyMisService.setCompanyRiderRatio', params, 'POST');
}

// 新 财务信息，结算设置
export async function setCompanyRiderRatioV2(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.user.company.CompanyMisService.setCompanyRiderRatioV2', params, 'POST');
}

// 财务信息，接单保证金设置
export async function setCompanyRiderDeposit(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.user.company.CompanyMisService.setCompanyRiderDeposit', params, 'POST');
}
